/** 将对象转为 FormData；数组按 key[] 追加；对象值 JSON.stringify */
export function toFormData(params?: Record<string | number, unknown>) {
  const formData = new FormData()
  if (!params) return formData
  Object.entries(params).forEach(([k, v]) => {
    if (Array.isArray(v)) {
      v.forEach((val) =>
        formData.append(`${k}[]`, typeof val === 'object' ? JSON.stringify(val) : String(val)),
      )
    } else if (typeof v === 'object' && v !== null) {
      formData.append(k, JSON.stringify(v))
    } else if (v !== null && v !== undefined) {
      formData.append(k, String(v))
    }
  })
  return formData
}

/** 将对象转为 application/x-www-form-urlencoded（支持嵌套/数组） */
export function toUrlencoded(params: Record<string | number, unknown>) {
  const urlencoded = new URLSearchParams()
  function walk(obj: Record<string | number, unknown>, parent = '') {
    for (const [k, v] of Object.entries(obj)) {
      const key = parent ? `${parent}[${k}]` : k
      if (v === null || v === undefined) continue
      if (Array.isArray(v)) {
        v.forEach((item) =>
          urlencoded.append(
            `${key}[]`,
            typeof item === 'object' ? JSON.stringify(item) : String(item),
          ),
        )
      } else if (typeof v === 'object') {
        walk(v as Record<string | number, unknown>, key)
      } else {
        urlencoded.append(key, String(v))
      }
    }
  }
  walk(params)
  return urlencoded
}
